// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"_2jpMuhr","cta":"_1PBm8XS","background":"_2TKjr3l","left":"_2_xA7Nc","center":"_3HswmNy","right":"_1m2Oe6w"};